import {OfferType} from "@pg-rp/common-types";

import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {SearchSort} from "../../offer/list/constants/SearchSort";
import {getCountriesList} from "../../region/utils/get_countries_list";
import {VendorDetailActiveOffersPageSize} from "../constants/VendorDetailActiveOffersPageSize";
import {IVendorDetailOfferListParams} from "../types/IVendorDetailOfferListParams";

const getVendorOfferListSortName = (searchSort: SearchSort): string | undefined => {
    switch (searchSort) {
        case SearchSort.PRICE:
            return "price";
        case SearchSort.PRICE_M2:
            return "price_m2";
        case SearchSort.LATEST:
            return "create_date";
        case SearchSort.CONSTRUCTION_DATE:
            return "construction_date_range";
        default:
            return undefined;
    }
};

export function convertToVendorDetailViewOffersPayload(params: {
    vendorId: number | null;
    region: number | null;
    displayType: OfferDisplayType;
    pageSize?: number;
    type?: OfferType | OfferType[];
    sort?: SearchSort;
}): IVendorDetailOfferListParams {
    const {vendorId, region, displayType, pageSize, type, sort} = params;

    const sortName = sort ? getVendorOfferListSortName(sort) : undefined;
    const typeArray = type ? (Array.isArray(type) ? type : [type]) : [OfferType.FLAT, OfferType.HOUSE];

    const fullQuery: IVendorDetailOfferListParams = {
        vendor: vendorId,
        page_size: pageSize ?? VendorDetailActiveOffersPageSize,
        country: getCountriesList(),
        ...(region !== null ? {region} : {}),
        display_type: displayType,
        limited_presentation: displayType === OfferDisplayType.FOR_SALE ? false : undefined,
        type: typeArray,
        is_active: true,
        ...(sortName ? {sort: sortName} : {})
    };

    return fullQuery;
}
